import {Divider, Typography} from '@sollapay/ui/components';

import type {ReactNode} from 'react';

export interface BreakdownSectionProps {
  label: string;
  children: ReactNode;
}

export function BreakdownSection({label, children}: BreakdownSectionProps) {
  return (
    <div data-slot="balance-breakdown-section" className="flex flex-col gap-3">
      <Divider className="bg-border-subtle" />
      <Typography size="xs" weight="bold" color="tertiary">
        {label}
      </Typography>
      {children}
    </div>
  );
}
